require("!!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\raw-loader\\index.js!C:\\Users\\Prakosa\\Documents\\FIF\\action-web\\node_modules\\handsontable\\dist\\handsontable.full.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/handsontable/dist/handsontable.full.js
// module id = 854
// module chunks = 3